export const RATING_COLORS = {
  success: "#2E9B4B",
  warning: "#F2A900",
  danger: "#D64545",
  muted: "#94A3B8",
};

export function colorFor(key) {
  return RATING_COLORS[key] || "#123D73";
}

export const AGE_GROUPS = [
  { value: "below_25", label: "Below 25" },
  { value: "25_35", label: "25–35" },
  { value: "36_45", label: "36–45" },
  { value: "46_55", label: "46–55" },
  { value: "56_65", label: "56–65" },
  { value: "65_plus", label: "65+" },
];

export const INCOME_RANGES = [
  { value: "below_5l", label: "Below ₹5 Lakh" },
  { value: "5_10l", label: "₹5–10 Lakh" },
  { value: "10_25l", label: "₹10–25 Lakh" },
  { value: "25_50l", label: "₹25–50 Lakh" },
  { value: "50l_1cr", label: "₹50 Lakh–₹1 Crore" },
  { value: "above_1cr", label: "Above ₹1 Crore" },
  { value: "prefer_not", label: "Prefer not to say" },
];

export const MARITAL = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "other", label: "Other" },
  { value: "prefer_not", label: "Prefer not to say" },
];

export const DEPENDENTS = [
  { value: "0", label: "None" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4+", label: "4+" },
];

export const CHILDREN = [
  { value: "0", label: "No children" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3+", label: "3+" },
];

export const EXISTING_INVESTMENTS = [
  "Mutual Funds", "SIP", "Stocks", "FD/RD", "PPF/EPF", "NPS",
  "Insurance Policies", "Gold", "Real Estate", "Other",
];

export const MONTHLY_INVESTMENT = [
  { value: "0", label: "₹0" },
  { value: "below_5k", label: "Below ₹5,000" },
  { value: "5k_10k", label: "₹5,000–₹10,000" },
  { value: "10k_25k", label: "₹10,000–₹25,000" },
  { value: "25k_50k", label: "₹25,000–₹50,000" },
  { value: "50k_1l", label: "₹50,000–₹1 Lakh" },
  { value: "above_1l", label: "Above ₹1 Lakh" },
];

export const PRIMARY_GOALS = [
  "Family Protection", "Children's Education", "Retirement", "Wealth Creation",
  "Buying a Home", "Children's Marriage", "Tax Planning", "Debt Reduction",
  "Emergency Fund", "Other",
];

export const FOLLOWUP_STATUSES = [
  "New", "Contacted", "Interested", "Meeting Scheduled", "Converted", "Not Interested", "Nurture",
];
